/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ManagerInfo } from './';
import {
    ManagerInfoFromJSON,
    ManagerInfoFromJSONTyped,
    ManagerInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientTeamSummary
 */
export interface ClientTeamSummary {
    /**
     * 
     * @type {string}
     * @memberof ClientTeamSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClientTeamSummary
     */
    name?: string;
    /**
     * 
     * @type {ManagerInfo}
     * @memberof ClientTeamSummary
     */
    manager?: ManagerInfo;
    /**
     * 
     * @type {number}
     * @memberof ClientTeamSummary
     */
    teamMemberCount: number;
}

/**
 * Check if a given object implements the ClientTeamSummary interface.
 */
export function instanceOfClientTeamSummary(value: object): value is ClientTeamSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('teamMemberCount' in value) || value['teamMemberCount'] === undefined) return false;
    return true;
}

export function ClientTeamSummaryFromJSON(json: any): ClientTeamSummary {
    return ClientTeamSummaryFromJSONTyped(json, false);
}

export function ClientTeamSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTeamSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'manager': json['manager'] == null ? undefined : ManagerInfoFromJSON(json['manager']),
        'teamMemberCount': json['teamMemberCount'],
    };
}

export function ClientTeamSummaryToJSON(value?: ClientTeamSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'manager': ManagerInfoToJSON(value['manager']),
        'teamMemberCount': value['teamMemberCount'],
    };
}

